import { render, staticRenderFns } from "./shopVipLevel.vue?vue&type=template&id=32b9d4f0&scoped=true"
import script from "./shopVipLevel.vue?vue&type=script&lang=js"
export * from "./shopVipLevel.vue?vue&type=script&lang=js"
import style0 from "./shopVipLevel.vue?vue&type=style&index=0&id=32b9d4f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b9d4f0",
  null
  
)

export default component.exports